<script setup>
import { computed } from 'vue';

import {
    ehVazio,
} from '@/commons/utils';

import {
    formataCpf,
    formataTelefone,
    formataDataRetirandoHora,
    formataMoedaReais,
} from '@kodatec/brasil-utils';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

const dadosBancariosFormatado = computed(() => {
    const d = props.solicitacao.dados;
    if (!d.banco_id && !d.chave_pix) return null;

    const partes = [];

    if (d.banco_agencia) {
        const agencia = d.banco_agencia_dv
            ? `${d.banco_agencia} - ${d.banco_agencia_dv}`
            : d.banco_agencia;
        partes.push(`Agência ${agencia}`);
    }

    if (d.banco_conta) {
        const conta = d.banco_conta_dv
            ? `${d.banco_conta} - ${d.banco_conta_dv}`
            : d.banco_conta;
        partes.push(`Conta ${conta}`);
    }

    if (d.banco_operacao) partes.push(`Operação ${d.banco_operacao}`);
    if (d.chave_pix) partes.push(`Chave PIX: ${d.chave_pix}`);

    return partes.join(' • ');
})

const enderecoFormatado = computed(() => {
    const partes = [];
    const d = props.solicitacao.dados;

    if (!ehVazio(d.endereco_logradouro)) partes.push(d.endereco_logradouro);
    if (!ehVazio(d.endereco_numero)) partes.push(d.endereco_numero);
    if (!ehVazio(d.endereco_complemento)) partes.push(d.endereco_complemento);
    if (!ehVazio(d.endereco_bairro)) partes.push(d.endereco_bairro);
    if (!ehVazio(d.endereco_cep)) partes.push(`CEP: ${d.endereco_cep}`);

    let endereco = partes.join(', ');

    if (!ehVazio(d.endereco_cidade)) {
        endereco += endereco ? ', ' : '';
        endereco += d.endereco_cidade;
    }

    if (!ehVazio(d.endereco_estado)) {
        endereco += `/${d.endereco_estado}`;
    }

    return endereco;
})
</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados v-if="solicitacao.dados.nome" titulo="Nome"
        :conteudo="solicitacao.dados.nome"
        :detalhe="solicitacao.dados.nome_social ? `Nome social: ${solicitacao.dados.nome_social}` : null" />

    <LabelDados v-if="solicitacao.dados.cpf" titulo="CPF"
        :conteudo="formataCpf(solicitacao.dados.cpf)" />

    <LabelDados v-if="solicitacao.dados.data_nascimento" titulo="Data de Nascimento"
        :conteudo="formataDataRetirandoHora(solicitacao.dados.data_nascimento)" />

    <LabelDados v-if="solicitacao.dados.telefone || solicitacao.dados.email" titulo="Contatos">
        <template #conteudo>
            <div v-if="solicitacao.dados.telefone" class="text-900 text-sm font-semibold">Telefone:
                {{ formataTelefone(solicitacao.dados.telefone) }}</div>
            <div v-if="solicitacao.dados.email" class="text-900 text-sm font-semibold">E-mail:
                {{ solicitacao.dados.email }}</div>
        </template>
    </LabelDados>

    <LabelDados v-if="solicitacao.dados.pis_nis_pasep" titulo="PIS/NIS/PASEP"
        :conteudo="solicitacao.dados.pis_nis_pasep" />

    <LabelDados
        v-if="solicitacao.dados.endereco_bairro || solicitacao.dados.endereco_cidade || solicitacao.dados.endereco_estado"
        titulo="Endereço" :conteudo="enderecoFormatado" />

    <LabelDados v-if="solicitacao.dados.renda_familiar != null" titulo="Renda Familiar"
        :conteudo="formataMoedaReais(solicitacao.dados.renda_familiar) && solicitacao.dados.renda_familiar !== 'None' ? formataMoedaReais(solicitacao.dados.renda_familiar) : 'Não informado'" />

    <LabelDados v-if="solicitacao.dados.numero_pessoas_casa != null" titulo="Número de Pessoas na Casa"
        :conteudo="String(solicitacao.dados.numero_pessoas_casa)" />

    <LabelDados v-if="dadosBancariosFormatado" titulo="Dados Bancários"
        :conteudo="dadosBancariosFormatado" tamanho_div="col-12" />
</template>
